<script>
import CrudListVue from '@/app/arch/components/crud/CrudList.vue';
import DataTableCurrencyColumnVue from '@/app/arch/components/data-table/DataTableColumns/DataTableCurrencyColumn.vue';
import DataTableCpfCnpjColumnVue from '@/app/arch/components/data-table/DataTableColumns/DataTableCpfCnpjColumn.vue';
import DataTableDateColumnVue from '@/app/arch/components/data-table/DataTableColumns/DataTableDateColumn.vue';
import ConciliationRequest from './ConciliationRequest';
import ConciliationStatusColumnVue from './components/ConciliationStatusColumn.vue';
import ConciliationViewColumnVue from './components/ConciliationViewColumn.vue';

export default {
  name: 'ConciliationCrudList',
  extends: CrudListVue,
  data: () => ({
    requestClass: ConciliationRequest,
    hideEdit: true,
    hideDelete: true,
    headers: [
      {
        text: 'Código',
        value: 'id',
      },
      {
        text: 'Valor',
        value: 'value',
        component: DataTableCurrencyColumnVue,
      },
      {
        text: 'Banco',
        value: 'originBankName',
      },
      {
        text: 'Código do banco',
        value: 'originBankCode',
      },
      {
        text: 'Agência',
        value: 'originAgency',
      },
      {
        text: 'Conta bancária',
        value: 'originAccount',
      },
      {
        text: 'Nome',
        value: 'originName',
      },
      {
        text: 'CNPJ/CPF',
        value: 'originDocument',
        component: DataTableCpfCnpjColumnVue,
      },
      {
        text: 'Data do crédito',
        value: 'effectiveDate',
        component: DataTableDateColumnVue,
      },
      {
        text: 'Data da conciliação',
        value: 'createdAt',
        component: DataTableDateColumnVue,
      },
      {
        text: 'Status da conciliação',
        value: 'statusConciliation',
        component: ConciliationStatusColumnVue,
      },
      {
        text: 'Ação',
        value: 'id',
        component: ConciliationViewColumnVue,
      },
    ],
  }),
  methods: {
    prepareRequest(params) {
      return this.requestClass.list(
        this.defaultParams(params),
      );
    },
    defaultParams(params = {}) {
      return {
        ...params,
      };
    },
  },
};
</script>
